import dayjs from "dayjs";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportMateriaisControladosUseCase } from "../../../presentation/useCases/read/get_report_materiais_controlados_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportMateriaisControladosUseCase
 */

export class GetReportMateriaisControladosUseCase implements IGetReportMateriaisControladosUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportMateriaisControlados(
    requiredMimeType: ReportMimeType | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportMateriaisControlados(
      requiredMimeType,
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `materiais_controlados_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
